module.exports = __webpack_public_path__ + "static/media/GratitudeENG.e51235de.vtt";